import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	addUriButton: {
		alignSelf: 'flex-start',
	},
	error: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
		marginBottom: THEME.spacing.xs,
	},
	optionalHint: {
		color: THEME.colors.text.light,
		fontWeight: THEME.typography.fontWeights.standard,
	},
	scopeDisabled: {
		color: THEME.colors.text.light,
		cursor: 'not-allowed',
	},
	scopeOption: {
		cursor: 'pointer',
	},
	scopes: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	uriRow: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
	},
	uriRowInput: {
		flexGrow: 1,
	},
});
